(function () {
  function init() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;

    var children = Array.from(desc.children);
    var ulIndex = 0;
    var isFirstLabel = true;

    children.forEach(function (el) {
      var tag = el.tagName.toLowerCase();

      if (tag === 'p' && el === children[0]) {
        insertLabel(el, 'Description', isFirstLabel);
        isFirstLabel = false;
      } else if (tag === 'ul' || tag === 'ol') {
        ulIndex++;
        if (ulIndex === 1) {
          insertLabel(el, 'Details', isFirstLabel);
          isFirstLabel = false;
        } else if (ulIndex === 2) {
          insertLabel(el, 'Materials & Specs', isFirstLabel);
          isFirstLabel = false;
        } else if (ulIndex >= 3) {
          insertLabel(el, 'Additional Info', isFirstLabel);
          isFirstLabel = false;
        }
      }
    });
  }

  function insertLabel(el, text, isFirst) {
    var label = document.createElement('p');
    label.className = 'wsu-desc-label' + (isFirst ? ' wsu-desc-label--first' : '');
    label.textContent = text;
    el.parentNode.insertBefore(label, el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
